"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertsComponent = void 0;
var React = require("react");
var Localize_1 = require("../../gen-src/Localize");
var Alert_1 = require("../icons/Alert");
var Check_1 = require("../icons/Check"); // swap later with icon to match UX
var Notification_1 = require("../icons/Notification"); // swap out later
var styles = require("../styles/PredictionModelResultsViz");
var PredictionModelVizCardButton_1 = require("./PredictionModelVizCardButton");
var AlertsComponent = function (props) {
    var numDataAlerts = props.numDataAlerts, passedQualityCheck = props.passedQualityCheck, title = props.title, description = props.description, hideBorder = props.hideBorder, buttonLabel = props.buttonLabel, onButtonClick = props.onButtonClick;
    var renderQualityCheckResult = function () {
        if (passedQualityCheck) {
            return (React.createElement("label", { className: styles.alertsQualityCheckMessage },
                React.createElement(Check_1.Check, null),
                Localize_1.Messages.NoIssuesMessage()));
        }
        return (React.createElement("label", { className: styles.alertsQualityCheckMessage },
            React.createElement(Alert_1.Alert, null),
            Localize_1.Messages.IssuesDetectedMessage()));
    };
    return (React.createElement("div", { className: hideBorder ? styles.cardContainer : styles.cardContainer + ' ' + styles.cardBorderShadow },
        React.createElement("div", { className: hideBorder ? styles.card : styles.cardBorder + ' ' + styles.card },
            title && React.createElement("label", { className: styles.cardTitle }, title),
            description && React.createElement("label", { className: styles.cardDescription }, description),
            React.createElement("div", { className: styles.alertsSection },
                React.createElement("label", { className: styles.alertsHeader }, Localize_1.Messages.ModelQualityCheck()),
                renderQualityCheckResult()),
            React.createElement("div", { className: styles.alertsSection },
                React.createElement("label", { className: styles.alertsHeader }, Localize_1.Messages.DataAlerts()),
                React.createElement("label", { className: styles.alertsNumDataAlertsText },
                    React.createElement(Notification_1.Notification, null),
                    numDataAlerts))),
        onButtonClick && buttonLabel && React.createElement(PredictionModelVizCardButton_1.PredictionModelVizCardButton, { onClick: onButtonClick, label: buttonLabel })));
};
exports.AlertsComponent = AlertsComponent;
//# sourceMappingURL=AlertsComponent.js.map